import type {WorkMetadata} from 'services/metadata/types';
import {mapWorkFlattenedDto} from 'services/metadata';

export async function loadMockWork(key: string): Promise<WorkMetadata> {
  return await import(`./data/${key}.json`, {with: {type: 'json'}}).then(
    mapWorkFlattenedDto,
  );
}
